module.exports = __webpack_public_path__ + "img/97.863c3117.svg";